import { orderBy } from 'lodash';

export const sortCustomToneOfVoice = (items) =>
  orderBy(items, ['isDefault', 'updatedAt', 'name', 'id'], ['desc', 'desc', 'asc', 'asc']);
